import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import Questions from './questions.js';
import FinanceStats from "./FinanceStats";
import SpecialStats from "./SpecialStats";
import EdumatStats from "./EdumatStats";
import AccessLog from './accessLog';
import UsersStats from "./usersStats";
import UsersOverview from "./usersOverview";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css'

class Statistics extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeKey: 1,
        };

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(key) {
        this.setState({
          activeKey: key,
        });
    }

    render(){
        const {activeKey} = this.state;
        return (
            <div id="page-statistics" className="right-col" role="main">
                <div>
                    <h3>Statistiky</h3>
                </div>
                <Tabs
                  className="tabs"
                  activeKey={activeKey}
                  id="tabs"
                  onSelect={this.handleSelect}
                >
                    <Tab eventKey={1} title="Uživatelé - přehled">
                      <UsersOverview {...this.props} active={activeKey===1} />
                    </Tab>
                    <Tab eventKey={2} title="Uživatelé - statistiky">
                      <UsersStats {...this.props} active={activeKey===2}/>
                    </Tab>
                    <Tab eventKey={3} title="Otázky">
                        <Questions {...this.props} active={activeKey===3}/>
                    </Tab>
                    <Tab eventKey={4} title="Speciály">
                        <SpecialStats {...this.props} active={activeKey===4}/>
                    </Tab>
                    <Tab eventKey={5} title="Vzdělávací materiály">
                        <EdumatStats {...this.props} active={activeKey===5}/>
                    </Tab>
                    <Tab eventKey={6} title="Počet uživatelů">
                        <AccessLog {...this.props} active={activeKey===6}/>
                    </Tab>
                    <Tab eventKey={7} title="Finance">
                        <FinanceStats {...this.props} active={activeKey===7}/>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Statistics));



/** WEBPACK FOOTER **
 ** ./src/containers/Statistics/index.js
 **/